"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepEqSlow = exports.assertIsInt16 = exports.assertIsByteUnsigned = exports.assertIsByte = exports.shouldNotExecute = exports.loopLimit = exports.failed = exports.notEq = exports.eqFuzzy = exports.eq = exports.isIn = exports.notIn = exports.onlyOneIsNotNil = exports.inRange = exports.notEmptyString = exports.notUndefined = exports.notEmpty = exports.notNil = exports.nil = exports.f = exports.t = void 0;
var assert_sidecar_1 = require("./assert-sidecar");
var imports_1 = require("./imports");
function t(condition) {
    var error = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        error[_i - 1] = arguments[_i];
    }
    if (!condition) {
        var message = 'ERROR assert failed';
        var fullMessage = '';
        for (var i = 0; i < error.length; i++) {
            fullMessage += '|';
            fullMessage += error[i];
        }
        console.error.apply(console, __spreadArray([message], __read(error), false));
        throw new Error(message + fullMessage);
    }
}
exports.t = t;
function f(condition) {
    var error = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        error[_i - 1] = arguments[_i];
    }
    t.apply(void 0, __spreadArray([!condition], __read(error), false));
}
exports.f = f;
function nil(item) {
    var error = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        error[_i - 1] = arguments[_i];
    }
    t.apply(void 0, __spreadArray([item === null || item === undefined, 'nil'], __read(error), false));
}
exports.nil = nil;
function notNil(item) {
    var error = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        error[_i - 1] = arguments[_i];
    }
    t.apply(void 0, __spreadArray([item !== null && item !== undefined, 'notNil'], __read(error), false));
}
exports.notNil = notNil;
function notEmpty(item) {
    var error = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        error[_i - 1] = arguments[_i];
    }
    t.apply(void 0, __spreadArray([item != null && item.length > 0, 'notEmpty'], __read(error), false));
}
exports.notEmpty = notEmpty;
function notUndefined(item) {
    var error = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        error[_i - 1] = arguments[_i];
    }
    t.apply(void 0, __spreadArray([item !== undefined, 'notUndefined'], __read(error), false));
}
exports.notUndefined = notUndefined;
function notEmptyString(item) {
    var error = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        error[_i - 1] = arguments[_i];
    }
    t.apply(void 0, __spreadArray([item != null && item != '' && item.trim().length > 0,
        'notEmptyString'], __read(error), false));
}
exports.notEmptyString = notEmptyString;
function inRange(v, min, max) {
    var error = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        error[_i - 3] = arguments[_i];
    }
    assert_sidecar_1.assert.t.apply(assert_sidecar_1.assert, __spreadArray([v >= min && v <= max, 'range error', v, min, max], __read(error), false));
}
exports.inRange = inRange;
function onlyOneIsNotNil(a, b) {
    var error = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        error[_i - 2] = arguments[_i];
    }
    f.apply(void 0, __spreadArray([a == null && b == null, 'both nil'], __read(error), false));
    f.apply(void 0, __spreadArray([a != null && b != null, 'both not nil'], __read(error), false));
}
exports.onlyOneIsNotNil = onlyOneIsNotNil;
function notIn(array, item) {
    var error = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        error[_i - 2] = arguments[_i];
    }
    t.apply(void 0, __spreadArray([!imports_1.l.includes(array, item), 'notIn'], __read(error), false));
}
exports.notIn = notIn;
function isIn(array, item) {
    var error = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        error[_i - 2] = arguments[_i];
    }
    t.apply(void 0, __spreadArray([imports_1.l.includes(array, item), 'isIn'], __read(error), false));
}
exports.isIn = isIn;
function eq(a, b) {
    var error = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        error[_i - 2] = arguments[_i];
    }
    t.apply(void 0, __spreadArray([a === b, 'eq', a, b], __read(error), false));
}
exports.eq = eq;
function eqFuzzy(a, b) {
    var error = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        error[_i - 2] = arguments[_i];
    }
    if (imports_1.l.isNumber(a) && imports_1.l.isNumber(b)) {
        t.apply(void 0, __spreadArray([Math.abs(a - b) < 0.01, a, b], __read(error), false));
    }
    else {
        t.apply(void 0, __spreadArray([a === b, 'eq', a, b], __read(error), false));
    }
}
exports.eqFuzzy = eqFuzzy;
function notEq(a, b) {
    var error = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        error[_i - 2] = arguments[_i];
    }
    t.apply(void 0, __spreadArray([a !== b, 'not-eq'], __read(error), false));
}
exports.notEq = notEq;
function failed() {
    var error = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        error[_i] = arguments[_i];
    }
    t.apply(void 0, __spreadArray([false], __read(error), false));
}
exports.failed = failed;
function loopLimit(loopCount, max) {
    var error = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        error[_i - 2] = arguments[_i];
    }
    if (loopCount > max) {
        t.apply(void 0, __spreadArray([false, 'loop hit limit', max], __read(error), false));
    }
}
exports.loopLimit = loopLimit;
function shouldNotExecute() {
    var error = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        error[_i] = arguments[_i];
    }
    failed.apply(void 0, __spreadArray(['should not excute'], __read(error), false));
    throw new Error('Unreachable code');
}
exports.shouldNotExecute = shouldNotExecute;
function assertIsByte(v) {
    var erro = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        erro[_i - 1] = arguments[_i];
    }
    t(v >= -128 && v <= 127, 'byte out of range', v);
}
exports.assertIsByte = assertIsByte;
function assertIsByteUnsigned(v) {
    var erro = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        erro[_i - 1] = arguments[_i];
    }
    t(v >= 0 && v <= 255, 'ubyte out of range', v);
}
exports.assertIsByteUnsigned = assertIsByteUnsigned;
function assertIsInt16(v) {
    var erro = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        erro[_i - 1] = arguments[_i];
    }
    t(v >= -32768 && v <= 32767, 'Int16 out of range', v);
}
exports.assertIsInt16 = assertIsInt16;
var _verboseDeepSlow = false;
function deepEqSlow(a, b) {
    var error = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        error[_i - 2] = arguments[_i];
    }
    var keys = Object.keys(a);
    var keys2 = Object.keys(b);
    assert_sidecar_1.assert.eq(keys.length, keys2.length, 'different keys', error);
    imports_1.l.forEach(keys, function (c) {
        var a1 = a[c];
        var b1 = b[c];
        if (_verboseDeepSlow) {
            console.log('test a1 vs b1', c, a1, b1);
        }
        if (imports_1.l.isArray(a1)) {
            _deepEqArray.apply(void 0, __spreadArray([a1, b1, c], __read(error), false));
        }
        else if (imports_1.l.isObject(a1)) {
            var a1v = a1;
            var b1v = b1;
            if (a1v.x != null && a1v.y != null) {
                assert_sidecar_1.assert.eqFuzzy(a1v.x, b1v.x);
                assert_sidecar_1.assert.eqFuzzy(a1v.y, b1v.y);
            }
            else {
                assert_sidecar_1.assert.failed.apply(assert_sidecar_1.assert, __spreadArray(['cant do this deep get', c, a1], __read(error), false));
            }
        }
        else {
            assert_sidecar_1.assert.eqFuzzy.apply(assert_sidecar_1.assert, __spreadArray([a1, b1], __read(error), false));
        }
    });
}
exports.deepEqSlow = deepEqSlow;
function _deepEqArray(a1, b1, key) {
    var error = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        error[_i - 3] = arguments[_i];
    }
    assert_sidecar_1.assert.eq.apply(assert_sidecar_1.assert, __spreadArray([a1.length, b1.length, key, 'array different lengths'], __read(error), false));
    for (var i = 0; i < a1.length; i++) {
        var vArrA = a1[i];
        var vArrB = b1[i];
        if (_verboseDeepSlow) {
            console.log('test a1 vs b1', key, i, vArrA, vArrB);
        }
        if (imports_1.l.isArray(vArrA)) {
            _deepEqArray.apply(void 0, __spreadArray([vArrA, vArrB, key + '|' + i], __read(error), false));
        }
        else if (imports_1.l.isObject(vArrA)) {
            assert_sidecar_1.assert.failed.apply(assert_sidecar_1.assert, __spreadArray(['cant do this deep get', key, vArrA], __read(error), false));
        }
        else {
            assert_sidecar_1.assert.eqFuzzy.apply(assert_sidecar_1.assert, __spreadArray([vArrA, vArrB, key], __read(error), false));
        }
    }
}
